<div>
  <img class="w-80 mx-auto mb-8" [src]="src" />
  <div class="text-center">
    <p *ngIf="step" class="text-grey text-sm tracking-wide">{{ step }}</p>
    <h4 class="mb-8 text-grey-dark">{{ title }}</h4>
    <p class="text-sm text-grey-dark leading-7">{{ text }}</p>
  </div>
</div>
